// TODO: consolidate with the config files

export const Settings = {
  AV_CHECKIN_INTERVAL: 2 * 60 * 1000,

  PUBSUB: {
    STATS_COLLECTION_INTERVAL: 1 * 60 * 1000,

    // A connection is considered poor if
    // - ping rtt spikes above POOR_CONNECTION_EXTREME_PING_THRESHOLD in the last 5 measurements
    // - ping rtt spikes above POOR_CONNECTION_MAX_PING_THRESHOLD in the last 5 measurements and the
    // median of the last 5 ping times is greater than POOR_CONNECTION_MEDIAN_PING_THRESHOLD
    POOR_CONNECTION_EXTREME_PING_THRESHOLD: 5000,
    POOR_CONNECTION_MAX_PING_THRESHOLD: 2500,
    POOR_CONNECTION_MEDIAN_PING_THRESHOLD: 1000,
    // A connection is considered good if
    // - the max ping is less than GOOD_CONNECTION_MAX_PING_THRESHOLD in the last 5 measurements and
    // the median of the last 5 ping times is less than GOOD_CONNECTION_MEDIAN_PING_THRESHOLD
    GOOD_CONNECTION_MAX_PING_THRESHOLD: 2000,
    GOOD_CONNECTION_MEDIAN_PING_THRESHOLD: 1000,
    ROLLING_PING_RTT_LENGTH: 5,
  },
};
